import React from 'react';
import Datetime from './Datetime.jsx';

export default (props) => {
  return (
    <Datetime timeFormat={false} locale="fr-FR" {...props}>
      {props.children}
    </Datetime>
  );
};
